import React from 'react';
import { Link } from 'react-router-dom';

interface PastAttempt {
  id: string;
  score: number;
  total: number;
  passed: boolean;
  percentage: number;
  attempted_at: string;
}

interface GateIntroProps {
  unit: number;
  totalQuestions: number;
  passThreshold: number;
  timeLimitMinutes: number;
  onStart: () => void;
  eligible: boolean;
  weakAreas?: string[];
  pastAttempts?: PastAttempt[];
  onViewAttempt?: (attemptId: string) => void;
}

export const GateIntro: React.FC<GateIntroProps> = ({
  unit,
  totalQuestions,
  passThreshold,
  timeLimitMinutes,
  onStart,
  eligible,
  weakAreas,
  pastAttempts = [],
  onViewAttempt,
}) => {
  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    });
  };

  return (
    <div className="gate-intro">
      <h1>Unit {unit} Mastery Gate</h1>

      <div className="gate-info">
        <div className="info-item">
          <span className="info-label">Questions</span>
          <span className="info-value">{totalQuestions}</span>
        </div>
        <div className="info-item">
          <span className="info-label">To Pass</span>
          <span className="info-value">{passThreshold}+</span>
        </div>
        <div className="info-item">
          <span className="info-label">Time Limit</span>
          <span className="info-value">{timeLimitMinutes} min</span>
        </div>
      </div>

      {!eligible && weakAreas && weakAreas.length > 0 && (
        <div className="gate-warning">
          <h3>Not Ready Yet</h3>
          <p>Keep practicing these areas first:</p>
          <ul>
            {weakAreas.map(area => (
              <li key={area}>{area}</li>
            ))}
          </ul>
        </div>
      )}

      <button
        className="start-gate-button"
        onClick={onStart}
        disabled={!eligible}
      >
        {eligible ? 'Start Assessment' : 'Keep Practicing'}
      </button>

      {pastAttempts.length > 0 && (
        <div className="past-attempts">
          <h3>Past Attempts</h3>
          <div className="attempts-list">
            {pastAttempts.map((attempt) => (
              <button
                key={attempt.id}
                className={`attempt-row ${attempt.passed ? 'passed' : 'failed'}`}
                onClick={() => onViewAttempt?.(attempt.id)}
              >
                <span className="attempt-status">
                  {attempt.passed ? '✓' : '✗'}
                </span>
                <span className="attempt-score">
                  {attempt.score}/{attempt.total} ({attempt.percentage}%)
                </span>
                <span className="attempt-date">
                  {formatDate(attempt.attempted_at)}
                </span>
                <span className="attempt-arrow">→</span>
              </button>
            ))}
          </div>
        </div>
      )}

      <Link to="/" className="back-link">← Back to Dashboard</Link>
    </div>
  );
};
